import { render } from "./GestionMesas.vue?vue&type=template&id=b691dd46&scoped=true"
import script from "./GestionMesas.vue?vue&type=script&lang=js"
export * from "./GestionMesas.vue?vue&type=script&lang=js"

import "./GestionMesas.vue?vue&type=style&index=0&id=b691dd46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b691dd46"]])

export default __exports__